import type { BadgeVariant, MantineColor, MantineSize } from '@mantine/core'
import type { BaseReactProps, ReactNodeDef } from '@shared/node-v1.0.0'
import { getPortDef, sizes, margins } from '@shared/port-v1.0.0'
import Comp from '../component'

export type Props = BaseReactProps & {
	circle?: boolean
	fullWidth?: boolean
	w?: string
	label?: string
	variant: BadgeVariant
	autoContrast?: boolean
	color?: MantineColor
	size?: MantineSize
	radius?: MantineSize
	gradient?: { from: string; to: string; deg: number }
	leftIcon?: string
	rightIcon?: string
}


export default {
	hashTag: '#pre-release',
	module: { static: Comp },
	inNode: {
		inputs: [
			getPortDef({ name: 'label', displayName: 'Label', group: 'Params', type: 'string' }),
			
			getPortDef({
				name: 'leftIcon',
				displayName: 'Left Icon',
				group: 'Params',
				type: 'string',
			}),
			getPortDef({
				name: 'rightIcon',
				displayName: 'Right Icon',
				group: 'Params',
				type: 'string',
			}),
			
			getPortDef({ name: 'circle', displayName: 'Circle', group: 'Dimensions', type: 'boolean' }),
			getPortDef({
				name: 'size',
				displayName: 'Size',
				group: 'Dimensions',
				type: sizes,
				default: 'md',
			}),
			getPortDef({ name: 'fullWidth', displayName: 'Full width', group: 'Dimensions', type: 'boolean' }),
			getPortDef({ name: 'w', displayName: 'Width', group: 'Dimensions', type: 'string' }),
			getPortDef({
				name: 'radius',
				displayName: 'Radius',
				group: 'Styles',
				type: sizes,
				default: 'xl',
			}),
			getPortDef({ name: 'autoContrast', displayName: 'Auto Contrast', group: 'Styles', type: 'boolean' }),
			getPortDef({
				name: 'color',
				displayName: 'Color',
				group: 'Styles',
				type: 'string',
			}),
			getPortDef({
				name: 'variant',
				displayName: 'Variant',
				group: 'Styles',
				type: [
					{ value: 'filled', label: 'Filled' },
					{ value: 'light', label: 'Light' },
					{ value: 'outline', label: 'Outline' },
					{ value: 'dot', label: 'Dot' },
					{ value: 'gradient', label: 'Gradient' },
				],
				default: 'filled',
			}),
			getPortDef({
				name: 'gradient',
				displayName: 'Gradient',
				group: 'Styles',
				type: 'objectEval',
				dependsOn: (p: Props) => p.variant === 'gradient',
				codeComment: `// (props) => { return { from: 'blue', to: 'cyan', deg: 90 } }`,
			}),
			...margins,
		],
	},
	// disableCustomProps: true,
} satisfies ReactNodeDef
